<template>
    <a>
        <div class='comment_box' :class="`comment_index${index}`">
            <div class="col-md-1">
                <div class="comment_photo"><img :src="comment.UserAvatarURL" /></div>
            </div>
            <div class="col-md-9">
                <div class="comment_content">
                    <div class="comment_content_username">{{comment.UserNickName}} <span v-if="false">(s******567)</span> </div>
                    <div class="comment_content_date">{{comment.DBCreate | moment}}</div>
                    <div class="comment_content_vol">{{comment.Vol}}</div>
                    <div class="comment_star">
                        <div class="staricon_wrap" v-if="comment.RankStar">
                            <div class="icon" v-for="star of comment.RankStar" :key="star"></div>
                        </div>
                    </div>
                    <div class="comment_word">{{comment.Body}}</div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="comment-floor-div"><span class="comment-floor">#{{comment.Floor}}</span></div>
                <like :comment="comment"></like>
            </div>
        </div>
    </a>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'
import filters from './filters.js'
import Like from './Like.vue'


const showPages = 5

export default {
  name: 'Comment',
  props: ["comment","index"],
  data () {
    return {}
  },
  methods: {
    ...user,
    goPage (page) {
        this.now = page
    }
  },
  filters: {
    ...filters
  },
  computed: {
    interval () {
        // page 是一頁有幾個
        // showPages 是顯示幾個數字
        // 邏輯是，當點到最後一個數字，才會計算下一輪的 pagination 的數字
        // total,page,now,
        let itemPerPage = total/page
        let remain = total%page
        if (itemPerPage < 1) {
            return 1
        } else {
            now
        }

    }
  },
  components: {
    Like
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>


// WEBPACK FOOTER //
// src/Comment.vue